import { useCallback, useEffect } from "react";
import { Crisp } from "crisp-sdk-web";
const CRISP_WEBSITE_ID = "e33fde59-5bd3-43ef-906c-6d7297f22a08";

export default function CrispChat({ user }) {
  useEffect(() => {
    if (!user) return;

    Crisp.configure(CRISP_WEBSITE_ID, {
      locale: "en",
    });
    Crisp.setColorTheme("orange");
    Crisp.user.setEmail(user.email);
    Crisp.user.setNickname(user.name || user.email);
    Crisp.session.setData({
      company_id: user.storeId,
      plan: user.shopifyPlan,
      name: user.name,
      created_at: user.createdAt,
      recent_app: "DPDP Compliant",
      dpdp_compliant_installed: true,
      company_email: user.email,
      company_phone: user.shopPhone,
      shopify_store_url: user.url,
      partner_url: `https://partners.shopify.com/1182791/stores/${user.storeId}`,
      dev_access: `https://dev.shopify.com/dashboard/129552990/stores?store_type=collaborations&search_term=${encodeURIComponent(user.myShopifyDomain)}`,
      myshopify_domain: user.myShopifyDomain,
    });
    return () => {
      Crisp.chat.close();
    };
  }, [user]);

  return null;
}

export function useCrispLauncher() {
  const openChat = useCallback(() => {
    Crisp.chat.open();
  }, []);

  const closeChat = useCallback(() => {
    Crisp.chat.close();
  }, []);

  return { openChat, closeChat };
}
